module.exports = __webpack_public_path__ + "images/8c2aeb1.png";